/* global $, Hammer */
// Controllo se mi trovo nella pagina del dettaglio articolo
if ($('#dettaglio-articolo').length) {


  // Funzione di gestione della lightbox
  (function () {

    // cache degli elementi globali
    const $zoomWrapper = $('#wrapper-zoom');
    const $zoomContent = $('.image-zoom-content');
    const $closeWrapper = $('.close-image-zoom');
    const $zoomNext = $('.next-zoom');
    const $zoomPrev = $('.prev-zoom');

    // immagine dettaglio articolo
    const $imgDetails = $('.image-detail-content');

    // Variabile opeartiva di indice dell'immagine
    let zoomIndex = 0;


    /**
     * Funzione che chiude il wrapper (lightbox)
     */
    const closeWrapper = function () {
      if ($zoomWrapper.is(':visible')) {
        $zoomWrapper.fadeOut();
        $zoomContent.stop().animate({ opacity: 0 }, 100);
      }
    };


    /**
     * Funzione che mostra l'immagine zoom selezionata
     *
     * @param {number} index indice dell'immagine
     */
    const showZoom = function (index) {
      $('.image-zoom-content').stop().animate({ opacity: 0 }, 200);
      index = '.image-zoom-' + index + '';

      const $index = $('' + index + '');
      const $image = $('' + index + '').children('img');

      // reset per permettere il copia immagine corretto
      // setto lo z-index a -1 per tute le immagini e porto il valore
      // a 0 solo per l'immagine selezionata
      $('#wrapper-zoom img').css('z-index', '-1');
      $image.attr('z-index', '0');

      $index.stop().animate({ opacity: 1 }, 200);
    };


    // Funzione per visualizzare l'immagine precedente
    const showPrev = function () {

      // controllo che la lightbox ia aperta e visibile
      if ($zoomWrapper.is(':visible')) {

        // Decremento l'indice per mostrare l'immagine precedente
        zoomIndex -= 1;

        // Se l'indice è inferiore a 0 mostro l'ultima immagine della gallery
        if (zoomIndex === -1) {
          zoomIndex = $imgDetails.length - 1;
        }

        // Mostro l'immagine precedente
        showZoom(zoomIndex);
      }
    };


    // Funzione per visualizzare l'immagine successiva
    const showNext = function () {

      // controllo che la lightbox sia aperta e visibile
      if ($zoomWrapper.is(':visible')) {

        // conto il numero di thumb in modo da conoscere il numero di immagini
        // dell'articolo
        const maxDetails = $imgDetails.length;

        // Incremento l'indice per mostrare l'immagine successiva
        zoomIndex += 1;

        // Controllo se siamo oltre l'ultima immagine e resetto l'indice in modo
        // da ripartire dalla prima immagine
        if (zoomIndex === maxDetails) {
          zoomIndex = 0;
        }

        // Mostro l'immagine successiva
        showZoom(zoomIndex);
      }
    };


    // Apro la lightbox al click sull'imagine dettaglio
    // Mostro la zoom relativa all'immagine dettaglio mostrata
    $imgDetails.on('click', function () {
      $zoomWrapper.fadeIn();
      zoomIndex = parseInt($(this).attr('data-index-zoom'), 10);
      showZoom(zoomIndex);
    });


    // Chiudo il lightbox al click sul pulsante chiudi e resetto il contenuto
    $closeWrapper.on('click', function () {
      closeWrapper();
    });


    // Chiudo il lightbox allo scroll della pagina e resetto il contenuto
    $(window).scroll(function () {
      if ($(window).width() > 768) {
        closeWrapper();
      }
    });


    // Chiudo il lighbox alla pressione del pulsante ESC e resetto il contenuto
    $(window).keydown(function (key) {
      if (parseInt(key.keyCode, 10) === 27) {
        closeWrapper();
      }
    });


    // IMMAGINE PRECEDENTE - Click sulla freccia
    $zoomPrev.on('click', function () {
      showPrev();
    });


    // IMMAGINE PRECEDENTE - Pulsante freccia sx tastiera
    $(window).keydown(function (key) {
      if (parseInt(key.keyCode, 10) === 37) {
        showPrev();
      }
    });


    // immagine successiva
    $zoomNext.on('click', function () {
      showNext();
    });


    // IMMAGINE SUCCESSIVA - Pulsante freccia dx tastiera
    $(window).keydown(function (key) {
      if (parseInt(key.keyCode, 10) === 39) {
        showNext();
      }
    });


    // Definisco l'area per il detect dei touch event
    const swipeDetect = new Hammer($zoomWrapper[0]);

    // gestione degli Swipe
    swipeDetect.on('swipeleft', function () {
      if (!$('.mobile-zoom').hasClass('zoomed')) {
        showNext();
      }
    });
    swipeDetect.on('swiperight', function () {
      if (!$('.mobile-zoom').hasClass('zoomed')) {
        showPrev();
      }
    });

    // Al double-tap innesco la routine di zoom sull'immagine
    swipeDetect.on('doubletap', function () {
      if ($(window).width() < 768) {
        $('.mobile-zoom')[0].click();
      }
    });


    $('.mobile-zoom').on('click', function (index) {

      index = '.image-zoom-' + zoomIndex + '';
      const $index = $('' + index + '');

      if ($(this).hasClass('zoomed')) {

        // Attivo nuovamente la funzionalità di swipe
        swipeDetect.set({ touchAction: 'pan-y' });

        $(this).html('<span class="fa fa-search-plus fa-lg"></span>&nbsp;&nbsp;Ingrandisci');
        $(this).removeClass('zoomed');

        $index.css({
          width: '100%',
          height: 'auto',
          position: 'fixed',
          left: '50%',
          top: '50%'
        });

        $zoomWrapper.css('overflow', 'hidden');
        $zoomPrev.removeClass('hidden');
        $zoomNext.removeClass('hidden');


      } else {

        // Disattivo la funzionalità di swipe per evitare conflitti durante
        // lo scroll dell'immagine zoomata
        swipeDetect.set({ touchAction: 'pan-x pan-y' });

        $(this).html('<span class="fa fa-search-minus fa-lg"></span>&nbsp;&nbsp;Riduci');
        $(this).addClass('zoomed');

        const w = $index.children('img')[0].naturalWidth;
        const h = $index.children('img')[0].naturalHeight;

        const wl = Math.floor(w / 2);
        const hl = Math.floor(h / 2);

        $index.css({
          width: w,
          height: h,
          position: 'absolute',
          left: wl,
          top: hl
        });

        $zoomWrapper.css('overflow', 'scroll');
        $zoomPrev.addClass('hidden');
        $zoomNext.addClass('hidden');

      }

    });


  }());
}
